<template>
    <p
        class="hide-price title-mask"
        v-html="$t('md-house.verifyYourEmail')"
        v-click="{
            selector: '.link',
            callback: toVerify,
            modifier: {
                prevent: true,
                stop: true
            }
        }"
    ></p>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';

import { sendVowEmail } from '@/components/sign-log';
//  show logic : 1.  not logged in  2.  Login unverified email
export default {
    i18next: {
        ns: 'md-house'
    },
    computed: {

        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        
    },
    methods: {
        toVerify() {
            sendVowEmail({ user: this.user, isResend: true });
        }
    }
};
</script>

<style lang="scss">
.hide-price {
    .link {
        text-decoration: underline;
        color: var(--color-theme);
        cursor: pointer;
    }
}
</style>
